module.exports = __webpack_public_path__ + "static/media/untickIcon.47193002.svg";